import Text from './Text';
import * as React from 'react';
export const Heading = (props) => {
    const { children, ...otherProps } = props;
    return (React.createElement(Text, Object.assign({ type: "heading" }, otherProps), children));
};
Heading.displayName = 'Heading';
export default Heading;
//# sourceMappingURL=Heading.js.map